import React, { Component } from 'react';
import logo from './logo.svg';
import './contract.css';
import {
  Navbar,
  Nav,
  NavItem,
  Grid,
  Row,
  Col,
  Panel,
  Button
} from 'react-bootstrap';
import { PlayerCard } from '../Components/PlayerCard';
import { CustomNav } from '../Components/CustomNav';
import { ContractTable } from '../Components/ContractTable';
import { HenriChart } from '../Components/HenriChart';
import { makeData, Logo, Tips } from '../Utility/utility.js';
import axios from 'axios';
import { authHeader, requestOptions } from '../_helpers';
import { apiServerUrl } from '../config';
let pitt = require('../Mock/team-management-pit.json');

export class Contract extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prospects: makeData(),
      data: pitt,
      selectedPlayer: '',
      selectedPlayerCap: [],
      selectedPlayerSurplus: [],
      selectedPlayerHenri: [],
      selectedPlayerSeasons: [],
      selection: 1,
      playerList: [],
      loading: true
    };
    this.toggleActive = this.toggleActive.bind(this);
    //this.state.selectedPlayer = this.state.prospects[0];
    //this.state.selectedPlayer2 = this.state.prospects[1];
  }
  componentDidMount() {
    let currentComponent = this;
    axios
      .get(apiServerUrl + '/contract_central', requestOptions())
      .then(function(response) {
        console.log(response.data);
        if (response.data) {
          currentComponent.setState({
            playerList: response.data,
            loading: false
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  toggleActive(data) {
    console.log('data' + data);
    let currentComponent = this;
    axios
      .get(apiServerUrl + '/player_card?player_id=' + data, requestOptions())
      .then(function(response) {
        console.log(response.data);
        if (response.data) {
          let capHit = [];
          let surplus = [];
          let henri = [];
          let seasons = [];
          for (var i = 0; i < response.data.contract_info.length; i++) {
            capHit.unshift(response.data.contract_info[i].cap_hit);
            surplus.unshift(response.data.contract_info[i].surplus);
            henri.unshift(response.data.contract_info[i].henri);
            seasons.unshift(response.data.contract_info[i].season);
          }
          console.log(capHit, surplus, henri, seasons);
          currentComponent.setState({
            selectedPlayer: response.data,
            selectedPlayerCap: capHit,
            selectedPlayerSurplus: surplus,
            selectedPlayerHenri: henri,
            selectedPlayerSeasons: seasons
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
    /*
        if(this.state.selection == 1 )
        {
          this.setState({
              selectedPlayer: test,
              //selection: 2,
          });
        }
        else if (this.state.selection == 2) {
          this.setState({
              selectedPlayer2: test,
              selection: 1,
          });
        }
        */
  }

  render() {
    return (
      <div>
        <header className="nav">
          <CustomNav />
        </header>
        <div
          className="flex-grid"
          style={{ display: 'flex', alignItems: 'stretch' }}
        >
          <main
            className="main"
            style={{ display: 'flex', flexDirection: 'row' }}
          >
            <ContractTable
              filterable={false}
              style={{ margin: 0 }}
              toggleActive={this.toggleActive}
              players={this.state.playerList}
            />
          </main>
        </div>
        <div className="flex-grid" style={{ alignItems: 'baseline' }}>
          <div className="player" style={{ flex: 2 }}>
            {this.state.selectedPlayer && (
              <PlayerCard
                selectedPlayer={this.state.selectedPlayer}
                toggleActive={this.toggleActive}
              />
            )}
          </div>
          <aside className="aside" style={{ flexDirection: 'column' }}>
            {this.state.selectedPlayer && (
              <div className="side" style={{ backgroundColor: '#1e3c51' }}>
                <h4 style={{ textAlign: 'center', color: 'white' }}>
                  {this.state.selectedPlayer.player_name}
                </h4>
                <HenriChart
                  height={300}
                  width={500}
                  selectedPlayer={this.state.selectedPlayer}
                  cap={this.state.selectedPlayerCap}
                  surplus={this.state.selectedPlayerSurplus}
                  henri={this.state.selectedPlayerHenri}
                  seasons={this.state.selectedPlayerSeasons}
                />
              </div>
            )}
            {/*
                        <div class="side" style={{marginBottom: 0, backgroundColor: '#1e3c51'}}>
                            <h4 style={{textAlign: 'center', color: 'white'}}>PLAYER 2 HENRI</h4>
                            <HenriChart selectedPlayer={this.state.selectedPlayer2}/>
                        </div>
                        */}
          </aside>
        </div>
      </div>
    );
  }
}

export default Contract;



// WEBPACK FOOTER //
// ./src/Pages/Contract.js